module.exports = __webpack_public_path__ + "img/cachanchara.4443fd48.jpg";